import { useRef } from 'react';
import Input from '../Input';
import Table from '../Table';
import './list-page.css';

function ListPage({
    title,
    addButtonTitle,
    onClickAddButton = () => {},
    onChangeSearch = () => {},
    tableCols = [],
    dataFiltered = [],
    tablePageTotal,
    onChangeTablePage = () => {}
}) {
    const searchInputRef = useRef(null);

    return (
        <div className='list-container'>
            <header className='container-header'>
                <h1>{title}</h1>

                <button
                    onClick={onClickAddButton}
                    className='blue-button zoom-effect'
                >
                    {addButtonTitle}
                </button>
            </header>

            <div className='list-search'>
                <div className='list-search-input'>
                    <Input
                        ref={searchInputRef}
                        className='commom-input glass-effect-15'
                        type='text'
                        placeholder='Buscar'
                        shouldValidate={false}
                        maxLength={100}
                        onChange={onChangeSearch}
                    />
                </div>
            </div>

            <Table
                columns={tableCols}
                data={dataFiltered}
                pageTotal={tablePageTotal}
                onChangePage={onChangeTablePage}
                maxHeight='52vh'
                minWidth='576px'
            />
        </div>
    );
}

export default ListPage;